import { ReactElement } from 'react';

interface Props {
  className?: string;
}

function skipLastPage({ className }: Props): ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 19 20"
      width="19"
      height="20"
      fill="black"
      className={className}
    >
      <g stroke="none">
        <path d="M16 1.40475C16 0.852461 16.4477 0.404745 17 0.404745C17.5523 0.404745 18 0.85246 18 1.40475V19.4047C18 19.957 17.5523 20.4047 17 20.4047C16.4477 20.4047 16 19.957 16 19.4047V1.40475Z" />
        <path d="M1.30236 0.707106C0.91184 1.09763 0.911841 1.7308 1.30236 2.12132L9.35856 10.1775L0.707108 18.829C0.316584 19.2195 0.316584 19.8527 0.707108 20.2432C1.09763 20.6337 1.7308 20.6337 2.12132 20.2432L11.4269 10.9376C11.6174 10.7471 11.715 10.4989 11.7196 10.2493C11.7543 9.95566 11.659 9.64955 11.4337 9.42422L2.71658 0.707106C2.32605 0.316582 1.69289 0.316582 1.30236 0.707106Z" />
      </g>
    </svg>
  );
}

export default skipLastPage;
